export default __webpack_public_path__ + "static/media/logo_refaccionaria.0c0f1aca.png";